import { render, staticRenderFns } from "./DynamicAttributeConfigurationSluggableSeparator.vue?vue&type=template&id=fb23e2a2&"
import script from "./DynamicAttributeConfigurationSluggableSeparator.vue?vue&type=script&lang=ts&"
export * from "./DynamicAttributeConfigurationSluggableSeparator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports